// extracted by mini-css-extract-plugin
module.exports = {"bulkIssues":"Landing_bulkIssues__13u_F"};